import React from "react";

const dummySuggestions = [
  { id: 1, user: "Bob", message: "Add dark mode." },
  { id: 2, user: "Dana", message: "More export options." },
];

const SuggestionsPage = () => (
  <div className="p-8">
    <h2 className="text-2xl font-bold mb-6">Suggestions</h2>
    <table className="min-w-full bg-white border border-gray-200">
      <thead>
        <tr>
          <th className="py-2 px-4 border-b">ID</th>
          <th className="py-2 px-4 border-b">User</th>
          <th className="py-2 px-4 border-b">Message</th>
        </tr>
      </thead>
      <tbody>
        {dummySuggestions.map(item => (
          <tr key={item.id}>
            <td className="py-2 px-4 border-b text-center">{item.id}</td>
            <td className="py-2 px-4 border-b">{item.user}</td>
            <td className="py-2 px-4 border-b">{item.message}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SuggestionsPage;
